"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ErrorFallback = _interopRequireDefault(require("./ErrorFallback"));

var _ErrorRank = _interopRequireDefault(require("./ErrorRank"));

var _errorService = _interopRequireDefault(require("./errorService"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  (0, _createClass2["default"])(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      /**
       * We make use of the Sentry hub passed in props to report the application
       * error to the intended recipient Sentry project.
       */
      _errorService["default"].captureError(error, {
        rank: this.props.rank || _ErrorRank["default"].P0,
        tags: this.props.tags,
        sentryHub: this.props.sentryHub
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError && this.props.fallbackComponent !== null) {
        if ( /*#__PURE__*/_react["default"].isValidElement(this.props.fallbackComponent)) {
          return this.props.fallbackComponent;
        }

        return /*#__PURE__*/_react["default"].createElement(_ErrorFallback["default"], null);
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);
  return ErrorBoundary;
}(_react["default"].Component);

ErrorBoundary.propTypes = {
  children: _propTypes["default"].node,
  fallbackComponent: _propTypes["default"].node,
  rank: _propTypes["default"].oneOf((0, _values["default"])(_ErrorRank["default"])),
  tags: _propTypes["default"].object,
  sentryHub: _propTypes["default"].object
};
var _default = ErrorBoundary;
exports["default"] = _default;